export default __webpack_public_path__ + "static/media/Snd_LowerTCross.9e2fa2f7.mp3";